import React, { useState } from 'react';
import Spiner from '../../components/Spiner';
import accessLogic from '../../functions/logic/Access';
import { useSnackbar } from 'notistack';
import '../../scss/_global.scss';

export default function Login() {
    const [spiner, setSpiner] = useState(false)
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const { enqueueSnackbar } = useSnackbar();
    const keyEnter = (event) => {
        if (event.keyCode === 13) {
            loginClick()
        }
    }
    const loginClick = async (event) => {
        setSpiner(true);
        const resp = await accessLogic.loginLogic(username,password);
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false);
        if (!resp.error) {
            localStorage.setItem('userToken', resp.data.token)
            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

            // Escoge el basename según entorno
            const BASENAME = isLocalhost
                ? process.env.REACT_APP_BASENAME_LOCAL
                : process.env.REACT_APP_BASENAME_PROD2

            // Redirige
            window.location.href = BASENAME + resp.url;
        }
    }
    return (
        <>
            <Spiner opt={spiner} />
            <div className="hold-transition login-page">
                <div className="login-box">
                    <div className="login-logo">
                        <a href="../../index2.html"><b>{global.LOGIN_TITTLE}</b></a>
                    </div>
                    <div className="card">
                        <div className="card-body login-card-body">
                            <div className="login-box-msg">{global.LOGIN_SUB_TITTLE}</div>
                            <div className="input-group mb-3">
                                <input maxLength="30" minLength="1" onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setUsername(target.value)} type="email" className="form-control" placeholder={global.LOGIN_EMAIL_TXT} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_EMAIL} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input maxLength="20" minLength="1" onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setPassword(target.value)} type="password" className="form-control" placeholder={global.LOGIN_PASSWORD_TXT} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_PASS} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="icheck-primary">
                                        <input type="checkbox" id="remember" />
                                        <label htmlFor="remember">
                                            {global.LOGIN_REMEMBER}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <button onClick={loginClick} className="btn btn-primary btn-block">{global.LOGIN_BUTTON}</button>
                                </div>
                            </div>
                            <div className="social-auth-links text-center mb-3">
                            </div>
                            <div className="mb-1">
                                <a href={global.FORGOTPASSWORD}>{global.LOGIN_FORGOT_PASSSWORD}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}